import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Paper, Typography, Divider } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

import User from '../../../../models/User';
import Cart from '../../../../models/Cart';
import CartItem from '../../../../models/CartItem';
import cartRemote from '../../../../api/cartRemote';
import { receiveCart, updateWholeCart } from '../../../../store/actions/cartAction';
import { receiveError, receiveSuccess } from '../../../../store/actions/notificationAction';
import commonStyles from '../../../common/common.module.css';

interface GoPaymentPageState {
  loading: boolean;
  success: boolean;
}

interface GoPaymentPageProps extends RouteComponentProps {
  user: User;
  cart: Cart;
  getCartItems: () => void;
  updateCart: (cart: Cart) => void;
  showError: (error: any) => void;
  showSuccess: (msg: string) => void;
}

class GoPaymentPageContainer extends Component<GoPaymentPageProps, GoPaymentPageState> {
  constructor(props: GoPaymentPageProps) {
    super(props);
    this.state = {
      loading: false,
      success: false
    };
  }

  componentDidMount() {
    this.props.getCartItems();
  }

  handleBack = () => {
    this.props.history.push('/cart-go');
  }

  handleConfirmPayment = async () => {
    this.setState({ loading: true });
    
    try {
      const resp = await cartRemote.cartGenGo();
      
      if (resp.result) {
        this.props.updateCart(resp.result);
        this.props.showSuccess('GO Order generated successfully!');
        this.setState({ loading: false, success: true });
        
        // Redirect to GO Orders view after successful generation
        setTimeout(() => {
          this.props.history.push('/my-go-orders');
        }, 1500);

      } else if (resp.error) {
        this.props.showError(resp.error);
        this.setState({ loading: false });
      }
    } catch (e) {
      console.error('Payment failed:', e);
      this.setState({ loading: false });
    }
  }

  render() {
    const { cart } = this.props;
    const items = (cart && cart.items) ? cart.items : [];
    const hasItems = items.length > 0;
    const totalDue = (cart.remainDue || cart.totalDue || 0).toFixed(2);

    if (this.state.success) {
      return (
        <div className={ commonStyles.wrapper } style={{ marginTop: '40px', padding: '100px 20px', minHeight: '600px', backgroundColor: '#fff', borderRadius: '15px', textAlign: 'center' }}>
          <CheckCircleOutlineIcon style={{ fontSize: '80px', color: 'var(--secondarygreen)' }} />
          <Typography variant="h4" style={{ marginTop: '20px', color: 'var(--primaryblue)' }}>Order Confirmed!</Typography>
          <Typography style={{ color: '#666', marginTop: '10px' }}>Your GO Order has been successfully generated. Redirecting...</Typography>
        </div>
      );
    }

    return (
      <div className={ commonStyles.wrapper } style={{ marginTop: '40px', padding: '20px', minHeight: '600px', backgroundColor: '#fff', borderRadius: '15px' }}>
        <h3 className={ commonStyles.header }>Finalize Order</h3>
        <p style={{ color: '#666', marginTop: '20px' }}>
          Confirm the total charges and execute the generation of this Government Order.
        </p>

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
            <Paper style={{ padding: '40px', width: '100%', maxWidth: '600px', backgroundColor: '#f8f9fa', textAlign: 'center' }}>
              <Typography variant="h6" style={{ marginBottom: '30px', color: 'var(--primaryblue)' }}>Payment & Generation</Typography>
              
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px', fontSize: '18px' }}>
                <Typography color="textSecondary" style={{ fontSize: '18px' }}>Associated Shipments</Typography>
                <Typography style={{ fontSize: '18px', fontWeight: 600 }}>{items.length}</Typography>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '30px', fontSize: '18px' }}>
                <Typography color="textSecondary" style={{ fontSize: '18px' }}>Total Amount Due</Typography>
                <Typography style={{ fontSize: '18px', fontWeight: 600 }} color="primary">${totalDue}</Typography>
              </div>

              <Divider style={{ marginBottom: '40px' }} />

              <Button 
                color="primary"
                variant="contained"
                fullWidth
                style={{ padding: '15px', fontSize: '18px', borderRadius: '8px' }}
                disabled={this.state.loading || !hasItems}
                onClick={this.handleConfirmPayment}
              >
                { this.state.loading ? 'Processing...' : 'Confirm & Generate Order' }
              </Button>
            </Paper>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '40px' }}>
          <Button 
            variant="outlined"
            style={{ padding: '10px 30px', fontSize: '16px', borderRadius: '8px' }}
            disabled={this.state.loading}
            onClick={this.handleBack}
          >
            ← Back to Cart
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  user: state.user,
  cart: state.cart
});

const mapDispatchToProps = (dispatch: Function) => ({
  getCartItems: () => dispatch(receiveCart(true)),
  updateCart: (cart: Cart) => dispatch(updateWholeCart(cart)),
  showSuccess: (msg: string) => dispatch(receiveSuccess(msg)),
  showError: (error: any) => dispatch(receiveError(error))
});

export default connect(mapStateToProps, mapDispatchToProps)(GoPaymentPageContainer);
